import { render, staticRenderFns } from "./DictionariesSyncItem.vue?vue&type=template&id=15121571&scoped=true"
import script from "./DictionariesSyncItem.vue?vue&type=script&lang=js"
export * from "./DictionariesSyncItem.vue?vue&type=script&lang=js"
import style0 from "./DictionariesSyncItem.vue?vue&type=style&index=0&id=15121571&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15121571",
  null
  
)

export default component.exports